import common_axios from "./commonAxios";

export const getTodes = (filterEvent, currentPage, limit) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_information?accessId=1&filter=' + filterEvent + '&recordsPerPage=' + limit + '&page=' + currentPage);
    // console.log(dataPass);
    return dataPass;
};

export const uploadFile = (fileData) => {
    var dataPass = common_axios.post('nhspatientmanagement/upload_file', fileData, {
    });
    return dataPass;
};

export const HomePageData = (startRange, endRange, radioSelected) => {
    var dataPass = common_axios.get('nhspatientmanagement/home_graph?startRange=' + startRange + '&endRange=' + endRange + '&filterStatus=' + radioSelected);
    console.log(dataPass);
    return dataPass;
};

export const addUserService = (userData) => {
    var dataPass = common_axios.post('nhspatientmanagement/user_add', userData)
    return dataPass;
};

export const getProgramData = (filterEvent, currentPage, limit) => {
    var dataPass = common_axios.get('nhspatientmanagement/program_list');
    return dataPass;
};

export const getProgramDetails = (filterEvent, currentPage, limit, programId) => {
    var dataPass = common_axios.get('nhspatientmanagement/program_detail?filter=' + filterEvent + '&recordsPerPage=' + limit + '&page=' + currentPage);
    return dataPass;
};

export const getProgramDetailsv2 = (params) => {
    const queryParams = new URLSearchParams({
        division: params.division || '',
        practice: params.practice || '',
        status: params.status || '',
        page: params.page || 1,
        pageSize: params.pageSize || 50,
        sortFieldVal: params.sortField || '',
        smsStart: params.smsStart || '',
        smsEnd: params.smsEnd || '',
        sortDirectionVal: params.sortDirection || '',
        search: params.search || '',
        companyId: params.companyId || ''
    });

    for (const [key, value] of queryParams.entries()) {
        if (value === '') {
            queryParams.delete(key);
        }
    }

    const url = `nhspatientmanagement/program_detail_dummy?${queryParams.toString()}`;
    console.log('url', url);

    return common_axios.get(url);
};


export const delnhspatient = (postData) => {
    var dataPass = common_axios.post('nhspatientmanagement/delnhspatient', postData);
    return dataPass;
};

export const getAreaDrClinicList = (filterEvent, currentPage, limit) => {
    var dataPass = common_axios.get('nhspatientmanagement/area_dr_clinic_list');
    return dataPass;
};

export const getAreaDrClinicFilterList = (areaSelect, drSelect, clinicSelect, currentPage, limit) => {
    var dataPass = common_axios.get('nhspatientmanagement/area_dr_clinic_filter_list?areaId=' + areaSelect + '&clinicId=' + clinicSelect + '&doctorId=' + drSelect + '&recordsPerPage=' + limit + '&page=' + currentPage);
    return dataPass;
};

export const ServiceDivisionOverview = (areaSelect, drSelect, clinicSelect, currentPage, limit) => {
    var dataPass = common_axios.get('nhspatientmanagement/division_overview?areaId=' + areaSelect + '&clinicId=' + clinicSelect + '&doctorId=' + drSelect + '&recordsPerPage=' + limit + '&page=' + currentPage);
    return dataPass;
};

export const getHistory = (currentPage, limit) => {
    const page = currentPage !== undefined ? Number(currentPage) : 1;
    const pageSize = limit !== undefined ? Number(limit) : 10;
    var dataPass = common_axios.get('nhspatientmanagement/history?limit=' + pageSize + '&page=' + page);
    return dataPass;
};

export const getPmsUserList = (currentPage, limit, filterEvent, id) => {
    var dataPass = common_axios.get('nhspatientmanagement/pms_user_list?recordsPerPage=' + limit + '&page=' + currentPage + '&filter=' + filterEvent + '&id=' + id);
    return dataPass;
};

export const checkUsernameService = (userName) => {
    var dataPass = common_axios.get('nhspatientmanagement/check_username?userName=' + userName);
    return dataPass;
};

export const serviceGetClinic = (areaId) => {
    var dataPass = common_axios.get('nhspatientmanagement/clinic_list?areaId=' + areaId);
    return dataPass;
};
export const serviceAddClinic = (paramData) => {
    var dataPass = common_axios.post('nhspatientmanagement/clinic_add', paramData)
    return dataPass;
};
export const serviceGetarea = (areaId) => {
    var dataPass = common_axios.get('nhspatientmanagement/area_list?areaId=' + areaId);
    return dataPass;
};

export const serviceAddarea = (paramData) => {
    var dataPass = common_axios.post('nhspatientmanagement/area_add', paramData)
    return dataPass;
};

export const serviceAddDoctor = (paramData) => {
    var dataPass = common_axios.post('nhspatientmanagement/doctor_add', paramData)
    return dataPass;
};

export const serviceGetDoctor = (doctorId) => {
    var dataPass = common_axios.get('nhspatientmanagement/doctor_list?doctorId=' + doctorId);
    return dataPass;
};
export const serviceGetDoctorByClinic = (clinicId = '') => {
    var dataPass = common_axios.get('nhspatientmanagement/doctor_list_by_clinicid?clinicId=' + clinicId);
    return dataPass;
};

export const serviceCallDetailsGraph = (startRange, endRange, radioSelected) => {
    var dataPass = common_axios.get('nhspatientmanagement/call_detail_graph?startRange=' + startRange + '&endRange=' + endRange + '&filterStatus=' + radioSelected);
    return dataPass;
};

export const serviceMessageGraph = (startRange, endRange, radioSelected) => {

    var dataPass = common_axios.get('nhspatientmanagement/message_graph?startRange=' + startRange + '&endRange=' + endRange + '&userId=' + '&filterStatus=' + radioSelected);
    return dataPass;
};
export const ServiceInclinicList = (startRange, endRange) => {

    var dataPass = common_axios.get('nhspatientmanagement/inclinic_calldetails?startRange=' + startRange + '&endRange=' + endRange);
    return dataPass;
};
export const ServiceConsultationNotes = (callId) => {

    var dataPass = common_axios.get('nhspatientmanagement/consultation_notes?callId=' + callId);
    return dataPass;
};
export const ServicegetCommunication = (filterStatus, selectedStatus, exportExcel) => {
    var dataPass = common_axios.get('nhspatientmanagement/sms_communication?filterStatus=' + filterStatus + '&selectedStatus=' + selectedStatus + '&exportExcel=' + exportExcel);
    return dataPass;
};

// Fetching the Calls Details for Communication Center
export const CommunicationCallDetail = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/communication_center_call_stats', param);
    return dataPass;
}

// fetching the Message Details for Communication Center
export const CommunicationSmsDetail = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/communication_center_sms_stats', param);
    return dataPass;
}

// Fetching Sms Data for Communication Center
// export const serviceSmsData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
//     const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
//     var dataPass = common_axios.post('nhspatientmanagement/fetch_sms_data', param);
//     return dataPass;
// }

// fetching the Whatsapp Message Details for Communication Center
export const CommunicationWhatsappDetail = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/communication_center_whatsapp_stats', param);
    return dataPass;
}

// Fetching Whatsapp Data for Communication Center
// export const serviceWhatsappData = (startRange, endRange, selection, divisionClinicFilter, programSelect, pageNum) => {
//     const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect, 'pageNum': pageNum }
//     var dataPass = common_axios.post('nhspatientmanagement/fetch_whatsapp_data', param);
//     return dataPass;
// }

// In your service file (Service.js or similar)
export const serviceWhatsappData = (startRange, endRange, selection, divisionClinicFilter, programSelect, page = 1, limit = 10, exportType = '') => {
    const param = { 
        'startRange': startRange, 
        'endRange': endRange, 
        'selection': selection, 
        'divisionClinicFilter': divisionClinicFilter, 
        'programSelect': programSelect, 
        'page': page,
        'limit': limit,
        'exportType': exportType  // Add this parameter
    }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_whatsapp_data', param);
    return dataPass;
}

export const serviceSmsData = (startRange, endRange, selection, divisionClinicFilter, programSelect, page = 1, limit = 10, exportType = '') => {
    const param = { 
        'startRange': startRange, 
        'endRange': endRange, 
        'selection': selection, 
        'divisionClinicFilter': divisionClinicFilter, 
        'programSelect': programSelect, 
        'page': page,
        'limit': limit,
        'exportType': exportType
    }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_sms_data', param);
    return dataPass;
}

export const serviceCallData = (startRange, endRange, selection, divisionClinicFilter, programSelect, page = 1, limit = 10, exportType = '') => {
    const param = { 
        'startRange': startRange, 
        'endRange': endRange, 
        'selection': selection, 
        'divisionClinicFilter': divisionClinicFilter, 
        'programSelect': programSelect, 
        'page': page,
        'limit': limit,
        'exportType': exportType
    }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_call_data', param);
    return dataPass;
}


// For Fetch the Whatsapp chats
export const ServicegetWhatsappComm = (filterStatus, status, exportExcel) => {
    var dataPass = common_axios.get('nhspatientmanagement/whatsapp_communication?filterStatus=' + filterStatus + '&status=' + status + '&exportExcel=' + exportExcel);
    return dataPass;
};

// Fetch The Whatsapp Templates to show the template list
export const fetchTemplates = () => {
    var dataPass = common_axios.get('nhspatientmanagement/template_lists');
    return dataPass;
}


export const ServicegetCommunicationv1 = (params) => {

    const queryParams = new URLSearchParams({
        filterStatus: params.status || '',
        pageVal: params.page || 1,
        perPageVal: params.pageSize || 50,
        sortColumnVal: params.sortField || "",
        startDateVal: params.dateStart || "",
        endDateVal: params.dateEnd || "",
        sortOrderVal: params.sortDirection || "",
        searchVal: params.search || "",
    });



    for (const [key, value] of queryParams.entries()) {
        if (value === '') {
            queryParams.delete(key);
        }
    }

    const url = `nhspatientmanagement/sms_communication_v1?${queryParams.toString()}`;
    console.log('url', url);

    return common_axios.get(url);
};

export const ServicegetCommunicationAudio = (filterStatus) => {
    var dataPass = common_axios.get('nhspatientmanagement/sms_communication_audio_v1');
    return dataPass;
};


export const ServicegetCommunicationAudiov1 = (params) => {

    const queryParams = new URLSearchParams({
        pageVal: params.page || 1,
        perPageVal: params.pageSize || 50,
        sortColumnVal: params.sortField || "",
        startDateVal: params.dateStart || "",
        endDateVal: params.dateEnd || "",
        sortOrderVal: params.sortDirection || "",
        searchVal: params.search || "",
    });

    for (const [key, value] of queryParams.entries()) {
        if (value === '') {
            queryParams.delete(key);
        }
    }

    const url = `nhspatientmanagement/sms_communication_audio_v2?${queryParams.toString()}`;
    return common_axios.get(url);
};

export const ServiceResendSMS = (encId) => {

    var dataPass = common_axios.get('nhspatientmanagement/sms_resend?encId=' + encId);
    return dataPass;
};

export const ServiceGetProfile = (patientId) => {
    console.log("patientId", patientId);
    var dataPass = common_axios.get('nhspatientmanagement/profile?patientId=' + patientId);
    return dataPass;
}
export const sendMessage = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/sms_resend?encId=' + userId);
    return dataPass;
};
export const ServiceCallDetail = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_call_detail?userId=' + userId);
    return dataPass;
};
export const ServiceCoachNotes = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_coach_notes?userId=' + userId);
    return dataPass;
};
export const ServiceUserCoachChat = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_coach_chat?userId=' + userId);
    return dataPass;
};
export const ServiceUserHealthRecord = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_health_record?userId=' + userId);
    return dataPass;
};
export const ServiceSummaryData = (startDate, endDate) => {
    var dataPass = common_axios.get('nhspatientmanagement/inclinic_calldetails_overview?startDate=' + startDate + '&endDate=' + endDate);
    return dataPass;
};
export const ServiceShowFeed = (userId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_feeds?userId=' + userId);
    return dataPass;
};
export const ServiceAccountCreation = (data) => {
    var dataPass = common_axios.post('nhspatientmanagement/upload_file_new', data)
    return dataPass;
};
export const ServiceAccountUpdate = (data) => {
    var dataPass = common_axios.post('nhspatientmanagement/update_file_new', data)
    return dataPass;
};
export const ServiceVocList = (rating, startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'rating': rating, 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/voc_feedback_list_v2', param)
    return dataPass;
};
export const ServiceAllprogramList = () => {
    var dataPass = common_axios.post('nhspatientmanagement/all_program_list')
    return dataPass;
};

export const ServiceSaveSticky = (patientId, text) => {
    const data = { 'patientId': patientId, 'text': text }
    var dataPass = common_axios.post('nhspatientmanagement/stickynotes_add', data);
    return dataPass;
}
export const serviceSuperviewUserCount = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_usercount', param);
    return dataPass;
}

export const serviceSuperviewActiveUserCount = (startRange, endRange, divisionClinicFilter, programSelect,showExport='N') => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect, 'showExport':showExport}
    var dataPass = common_axios.post('nhspatientmanagement/fetch_active_user', param);
    return dataPass;
}

export const serviceExportData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/export_data', param);
    return dataPass;
}

export const servicePatientData = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_patient_count', param);
    return dataPass;
}

// export const serviceCallData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
//     const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
//     var dataPass = common_axios.post('nhspatientmanagement/fetch_call_data', param);
//     return dataPass;
// }

export const serviceInclinicData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_inclinic_data', param);
    return dataPass;
}



export const serviceMessageData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_message_data', param);
    return dataPass;
}

export const serviceUserOnboardingData = (startRange, endRange, selection, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'selection': selection, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_user_onboarding_data', param);
    return dataPass;
}



export const serviceSuperviewCoachRating = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_coachrating', param);
    return dataPass;
}
export const serviceSuperviewUserProgramCount = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_user_program', param);
    return dataPass;
}
export const serviceSuperviewUserDivisionCount = (startRange, endRange, divisionClinicFilter, programSelect,type='') => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect ,selectType:type}
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_user_division', param);
    return dataPass;
}
export const getReprtData = (startRange, endRange,rest={}) => {
    const param = { 'startRange': startRange, 'endRange': endRange,...rest }
    // var dataPass = common_axios.post('nhspatientmanagement/reports_data', param);
    var dataPass = common_axios.post('nhspatientmanagement/reports_data_2', param);
    return dataPass;
}
export const getReportsHistory =async () => {
    // const token = localStorage.getItem("authToken");
    // const config = {
    //     headers: {}
    // };
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    // return await common_axios.post('nhspatientmanagement/fetch_reports',{},config);
    return common_axios.post('nhspatientmanagement/fetch_reports',{});
}

export const storeReport = async (data) => {
    // const token = localStorage.getItem("authToken");
    // const config = {
    //     headers: {}
    // };
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    // const param = encodeURIComponent(JSON.stringify(data))
    // const url = `nhspatientmanagement/add_report`;
    // console.log("storeReport api url: ", url);
    // return await axios.post(url, {formData:JSON.stringify(data)}, config);
    return common_axios.post(
        "nhspatientmanagement/add_report",
        { formData: JSON.stringify(data) }
    );
};

export const serviceSuperviewUserDivisionPracticeCount = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_user_division_practice', param);
    return dataPass;
}
export const serviceSuperviewUserDivisionDateCount = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_user_division_date', param);
    return dataPass;
}
export const serviceSuperviewCallDetail = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_call_detail', param);
    return dataPass;
}
export const serviceSuperviewMesageGraph = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_message_graph', param);
    return dataPass;
}
export const serviceSuperviewInclinicCall = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/superoverview_inclinic_call_graph', param);
    return dataPass;
}
export const serviceFetchProgrammes = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_programs_users', param);
    return dataPass;
}
export const serviceFetchOnboardedPatients = (startRange, endRange, divisionClinicFilter, programSelect) => {
    const param = { 'startRange': startRange, 'endRange': endRange, 'divisionClinicFilter': divisionClinicFilter, 'programSelect': programSelect }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_onboard_patients', param);
    return dataPass;
}



export const serviceDivisionPractice = () => {
    const param = {}
    var dataPass = common_axios.get('nhspatientmanagement/division_practice', param);
    return dataPass;
}
export const serviceFetchFailedLogs = (docId, type = '') => {
    const param = { 'docId': docId, 'type': type }
    var dataPass = common_axios.post('nhspatientmanagement/uploaded_failed_logs', param);
    return dataPass;
}
export const serviceGetPatientDetail = (param1) => {
    const param = { 'pId': param1.updateId }
    var dataPass = common_axios.post('nhspatientmanagement/fetch_patient_detail', param);
    return dataPass;
}
export const serviceUpdatePatientDetail = (param1) => {
    const param = { 'pId': param1.updateId, 'email': param1.email, 'mobile': param1.mobile, 'confirm': param1.confirm, 'checkProgramId': param1.checkProgramId }
    var dataPass = common_axios.post('nhspatientmanagement/update_patient_detail', param);
    return dataPass;
}
export const serviceInclinicHourlyGraph = (startRange, endRange) => {
    const param = { 'startDate': startRange, 'endDate': endRange }
    var dataPass = common_axios.post('nhspatientmanagement/inclinic_hourly_graph', param);
    return dataPass;
}
export const serviceRenewPatient = (param) => {
    var dataPass = common_axios.post('nhspatientmanagement/renew_patient', param);
    return dataPass;
}
export const serviceProgramHistory = (patientId) => {
    var dataPass = common_axios.get('nhspatientmanagement/user_program_history?patientId=' + patientId);
    return dataPass;
}
export const sendBulkReminder = (param) => {
    console.log(param);
    var dataPass = common_axios.post('nhspatientmanagement/send_bulk_reminder', param);
    return dataPass;
}
export const serviceSmsTemplate = (templateId) => {
    var dataPass = common_axios.get('nhspatientmanagement/send_sms_template?templateId=' + templateId);
    return dataPass;
}
export const getInactiveUserExport = () => {
    var dataPass = common_axios.get('nhspatientmanagement/export_inactive_users');
    return dataPass;
}
export const ServiceSearchPatient = (searchTxt) => {
    const data = { 'searchTxt': searchTxt }
    var dataPass = common_axios.post('nhspatientmanagement/search_patient', data);
    return dataPass;
}


export const get_skin_diary = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/fetch_skin_diary', arg);
    return dataPass;
};

export const get_skin_diary_only_added = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/fetch_skin_diary_only_added', arg);
    return dataPass;
};

export const fetch_user_iframe_link = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/fetch_user_iframe_link', arg);
    return dataPass;
};


export const get_dlqi_plqi = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/fetch_dqli_psqi', arg);
    return dataPass;
};

export const fetchMarketingUser = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/marketing_user_fetch');
    return dataPass;
};

export const fetch_game_score = (arg) => {
    var dataPass = common_axios.post('nhspatientmanagement/fetch_game_score', arg);
    return dataPass;
};
export const get_link = (id, type) => {
    var dataPass = common_axios.get('nhspatientmanagement/fetch_link_v1?id=' + id + '&type=' + type);
    return dataPass;
}
export const get_lastupdated_time = () => {
    var dataPass = common_axios.get('nhspatientmanagement/fetch_updated_time');
    return dataPass;
}

export const session_form_post = (arg) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = 'nhspatientmanagement/save_room?' + arg;
    // console.log("save_room api url: ", url);
    
    // var dataPass = axios.post(url, {}, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/save_room?${arg}`
    );
};

export const fetch_video_call_sessions = (limit = 10, page = 1) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/fetch_video_call_sessions?limit=${limit}&page=${page}`;
    // // console.log("fetch_video_call_sessions api url: ", url);
    
    // var dataPass = axios.get(url, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/fetch_video_call_sessions?limit=${limit}&page=${page}`
    );
};

export const video_room_participants = (roomId) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/video_room_participants?roomId=${roomId}`;
    // // console.log("video_room_participants api url: ", url);
    
    // var dataPass = axios.get(url, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/video_room_participants?roomId=${roomId}`
    );
};

export const get_room_recordings = (roomId) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/video_room_recordings?roomId=${roomId}`;
    // // console.log("video_room_participants api url: ", url);
    
    // var dataPass = axios.get(url, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/video_room_recordings?roomId=${roomId}`
    );
};

export const save_new_participant = (roomId, participantMob) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/add_video_participant?roomId=${roomId}&participantMob=${participantMob}`;
    // // console.log("add_video_participant api url: ", url);
    
    // var dataPass = axios.post(url, {}, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/add_video_participant?roomId=${roomId}&participantMob=${participantMob}`
    );
};

export const sendInviteMessage = (roomId, invitePetients,type='whatsapp') => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/send_invitation_message?roomId=${roomId}&invitePetients=${invitePetients}&type=${type}`;
    // // console.log("add_video_participant api url: ", url);
    
    // var dataPass = axios.post(url, {}, config);
    // return dataPass;
    return common_axios.post(
        `nhspatientmanagement/send_invitation_message?roomId=${roomId}&invitePetients=${invitePetients}&type=${type}`
    );
};

export const video_participant_delete = (participantId, roomId) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/video_participant_delete?participantId=${participantId}&roomId=${roomId}`;
    // // console.log("video_participant_delete api url: ", url);
    
    // var dataPass = axios.get(url, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/video_participant_delete?participantId=${participantId}&roomId=${roomId}`
    );
};

export const delete_video_session = (roomId) => {
    // const token = localStorage.getItem("authToken");
    
    // const config = {
    //     headers: {}
    // };
    
    // if (token) {
    //     config.headers["Authorization"] = token;
    // }
    
    // const url = `nhspatientmanagement/remove_room?roomId=${roomId}`;
    // // console.log("delete_video_session api url: ", url);
    
    // var dataPass = axios.get(url, config);
    // return dataPass;
    return common_axios.get(
        `nhspatientmanagement/remove_room?roomId=${roomId}`
    );
};

export const getGLPUserList = (
    currentPage = 1,
    limit = 10,
    filterEvent = '',
    id = '',
    search = '',
    reportStatus = '',
    patientType = ''
) => {

    const params = new URLSearchParams();
    params.append('page', currentPage);
    params.append('recordsPerPage', limit);

    if (filterEvent) params.append('filter', filterEvent);
    if (id) params.append('id', id);
    if (search) params.append('search', search);
    if (reportStatus) params.append('reportStatus', reportStatus);
    if (patientType) params.append('patientType', patientType);

    return common_axios.get(
        `patientaction/userlist?${params.toString()}`
    );
};

/**
 * Updated to handle both File Upload and Inline Treatment Updates
 * for the GLP Pending Actions enhancement.
 */
// src/Services/Service.js
export const uploadConsultationReport = (patientId, data) => {
    const formData =Object.fromEntries(data);
    console.log('formData formData formData', formData);
    console.log('formData formData formData', formData);
    // Append file if it exists
    if (data.selectedFile) {
        formData.append('file', data.selectedFile);
    }

    return common_axios.post('patientaction/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

/**
 * Mark patient as DNA
 */
export const markPatientAsDNA = (cycleId, reason = '', reasonText = '', notes = '') => {
    // Validate required parameters
    if (!cycleId) {
        throw new Error('Missing required parameter: cycleId');
    }
    if (!reason) {
        throw new Error('Missing required parameter: reason');
    }
    
    // Send as FormData to align with API expectations
    const formData = new FormData();
    formData.append('cycle_id', cycleId);
    formData.append('cycleId', cycleId); // compatibility
    formData.append('reason', reason);
    formData.append('reason_text', reasonText || '');
    formData.append('reasonText', reasonText || ''); // compatibility
    formData.append('notes', notes || '');

    console.log("markPatientAsDNA payload", { cycleId, reason, reasonText, notes });

    return common_axios.post('patientaction/dna', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

/**
 * Update next consultation date
 */
export const updateNextConsultationDate = (cycleId, nextDate) => {
    return common_axios.put('patientaction/updatedate', {
        cycle_id: cycleId,
        next_consultation_date: nextDate
    });
};

/**
 * Get pending actions statistics
 */
export const getPendingActionsStats = () => {
    return common_axios.get('patientaction/stats');
};
/* Calling Api to for raise request */
export const ServiceRaiseRequest = ($requestData) => {
    var dataPass = common_axios.post('nhspatientmanagement/raise_modality_request', $requestData);
    return dataPass;
}

export const getICBRegionList = () => {
    var dataPass = common_axios.get('patientaction/icbregion');
    return dataPass;
}

export const getMyAppointments = () => {
    const params = new URLSearchParams(window.location.search);
    var dataPass = common_axios.get(
        'patientaction/myappointment',
        {
            params: {
                goqiiUserId: params.get('goqiiUserId')
                    ? params.get('goqiiUserId')
                    : params.get('goqiiuserid'),
                goqiiAccessToken: params.get('goqiiAccessToken')
                }
        }
    );
    return dataPass;
};

export const getMedicines = (page = 1, limit = 10, search = '') => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (search) {
        params.append('search', search);
    }
    return common_axios.get(`patientaction/medicines?${params.toString()}`);
}

export const getWhatsappLogs = (currentPage, limit, search) => {
    const page = currentPage !== undefined ? Number(currentPage) : 1;
    const pageSize = limit !== undefined ? Number(limit) : 10;
    let url = 'nhspatientmanagement/whatsapp_log_details?limit=' + pageSize + '&page=' + page;
    if (search !== undefined && search !== null && String(search).trim() !== '') {
        url += '&mobileno=' + encodeURIComponent(search);
    }
    var dataPass = common_axios.get(url);
    return dataPass;
};

export const getWhatsappUserMessages = (userId, currentPage, limit) => {
    const page = currentPage !== undefined ? Number(currentPage) : 1;
    const pageSize = limit !== undefined ? Number(limit) : 10;
    var dataPass = common_axios.get('nhspatientmanagement/whatsapp_user_messages?userId=' + userId + '&limit=' + pageSize + '&page=' + page);
    return dataPass;
}

export const dischargePatient = (cycleId, userId,reason) => {
    const formData = new FormData();
    formData.append('cycle_id', cycleId);
    formData.append('user_id', userId);
    formData.append('reason', reason);
    return common_axios.post(`patientaction/discharge`, formData);
};